// Routes du module « interventions » : Ma journée, planning, chantiers (préparation, page du chantier), liste des dépannages, assistant de création,
// espace de diagnostic, rapport. Les adresses existantes (/interventions/:id, /interventions/:id/rapport) ne changent pas.
import type { RouteObject } from 'react-router';
import '../../styles/interventions.css';
import '../../styles/chantiers.css';
import { PageInterventions } from './PageInterventions.tsx';
import { PageNouvelleIntervention } from './PageNouvelleIntervention.tsx';
import { PageIntervention } from './PageIntervention.tsx';
import { PageRapport } from './PageRapport.tsx';
import { PageChantiers } from './chantiers/PageChantiers.tsx';
import { PageChantier } from './chantiers/PageChantier.tsx';
import { PagePreparer } from './chantiers/PagePreparer.tsx';
import { PageMaJournee } from './chantiers/PageMaJournee.tsx';
import { PagePlanning } from './chantiers/PagePlanning.tsx';
import { PageJour } from './chantiers/PageJour.tsx';
import { PageEnvois } from './chantiers/PageEnvois.tsx';
import { PageRevision } from './chantiers/PageRevision.tsx';

export const routesInterventions: RouteObject[] = [
  { path: 'interventions', element: <PageInterventions /> },
  { path: 'interventions/nouvelle', element: <PageNouvelleIntervention /> },
  { path: 'interventions/journee', element: <PageMaJournee /> },
  { path: 'interventions/planning', element: <PagePlanning /> },
  { path: 'interventions/envois', element: <PageEnvois /> },
  { path: 'interventions/chantiers', element: <PageChantiers /> },
  { path: 'interventions/chantiers/:id', element: <PageChantier /> },
  { path: 'interventions/chantiers/:id/preparer', element: <PagePreparer /> },
  { path: 'interventions/chantiers/:id/jour/:jour', element: <PageJour /> },
  { path: 'interventions/chantiers/:id/revision', element: <PageRevision /> },
  { path: 'interventions/:id', element: <PageIntervention /> },
  { path: 'interventions/:id/rapport', element: <PageRapport /> },
];
